export default "__VITE_ASSET__b04fb66f__"